import React from "react";

import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

import { ConfigServiceCard } from "./ConfigServiceCard";
import { isAttached } from "./ConfigServices.utils";

import "./ConfigService.scss";

export const ConfigServices = () => {
	const configServiceGroups = useSelector(
		(state) => state.popup.configServiceGroups,
	);
	const attachedServices = useSelector(
		(state) => state.popup.attachedConfigServices,
	);

	// Services already in the cart are listed with the product instead
	const availableGroups = (configServiceGroups ?? []).filter(
		(group) => !isAttached(group, attachedServices),
	);

	if (!availableGroups.length) {
		return null;
	}

	return (
		<section
			className="addtocart-configServices__container"
			aria-labelledby="configServices__heading"
		>
			<h2 id="configServices__heading">{strings.configServicesHeader}</h2>

			{availableGroups.map((group) => (
				<ConfigServiceCard key={group.serviceGroupId} group={group} />
			))}
		</section>
	);
};
